export enum ProviderAccountPostStatus {
  Live = 'LIVE',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
}
